import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SortableList from "react-easy-sort";
import styles from "./Course.module.css";
import CourseCard from "./CourseCard";

const CourseList = ({
  courseList,
  onSortEnd,
  editCourse,
  onEditClick,
  onDeleteClick,
  theme_mode,
  onSetCourse,
  onSetCourseType,
  onSetCourseCategories,
  onUpdateCourse,
  onCancelCourse,
  CourseTypeList,
  categoryList,
  themeMode,
  editError,
}) => {
  return (
    <Box className={styles.courseListMainView}>
      <Typography
        className={styles.courseTitle}
        sx={{ color: theme_mode.text }}
      >
        Courses
      </Typography>
      <SortableList
        onSortEnd={onSortEnd}
        draggedItemClassName="course-order-dragged"
      >
        <Box
          mt={1}
          style={{
            height: window.innerHeight - 220,
            overflow: "auto",
            borderRadius: 10,
            padding: ".5rem",
          }}
        >
          {courseList.map((course) => (
            <CourseCard
              key={course._id}
              course={course}
              editCourse={editCourse}
              onEditClick={onEditClick}
              onDeleteClick={onDeleteClick}
              theme_mode={theme_mode}
              onSetCourse={onSetCourse}
              onSetCourseType={onSetCourseType}
              onSetCourseCategories={onSetCourseCategories}
              onUpdateCourse={onUpdateCourse}
              onCancelCourse={onCancelCourse}
              CourseTypeList={CourseTypeList}
              categoryList={categoryList}
              themeMode={themeMode}
              editError={editError}
            />
          ))}
        </Box>
      </SortableList>
    </Box>
  );
};

export default CourseList;
